import {
  useGroupLabel
} from "../__chunks/CTVLGQZG.js";
import "../__chunks/F5VAC7MB.js";
import {
  createComponent,
  createElement,
  createHook
} from "../__chunks/NQJBHION.js";
import "../__chunks/J7Q2EO23.js";
import "../__chunks/CP3U4HPL.js";
import {
  __objRest
} from "../__chunks/PNRLI7OV.js";

// src/form/form-group-label.ts
var useFormGroupLabel = createHook(
  (_a) => {
    var _b = _a, { store } = _b, props = __objRest(_b, ["store"]);
    props = useGroupLabel(props);
    return props;
  }
);
var FormGroupLabel = createComponent(
  (props) => {
    const htmlProps = useFormGroupLabel(props);
    return createElement("div", htmlProps);
  }
);
if (process.env.NODE_ENV !== "production") {
  FormGroupLabel.displayName = "FormGroupLabel";
}
export {
  FormGroupLabel,
  useFormGroupLabel
};
